import { Text, TextProps } from "@chakra-ui/react";

export default function SectionDescription({ children, ...rest }: TextProps) {
  return (
    <Text color="gray.500" fontSize="sm" {...rest}>
      {children}
    </Text>
  );
}
